// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"ce3f7665","641":"0ee3bae3","833":"69acd5bc"}[chunkId] + ".chunk.js";
};